import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { WeightHistoryData } from '../../../shared/models';
import { UserDataApiActions } from '../actions/user-data-api.actions';
import { v4 } from 'uuid';
import { ModalsActions } from '../../../core/modals/actions/modals.actions';

export interface WeightHistoryState extends EntityState<WeightHistoryData> {}

export const weightHistoryAdapter = createEntityAdapter<WeightHistoryData>({
  selectId: () => v4(),
});

const initialState = weightHistoryAdapter.getInitialState();

export const weightHistoryReducer = createReducer(
  initialState,
  on(UserDataApiActions.getUserWeightHistoryDataSuccess, (state, { payload }) =>
    weightHistoryAdapter.upsertMany(payload, { ...state })
  ),
  on(UserDataApiActions.purgeUserData, (state) => weightHistoryAdapter.removeAll({ ...state })),
  on(ModalsActions.closeUserDetailsModal, (state) => weightHistoryAdapter.removeAll({ ...state })),
  on(UserDataApiActions.getUserWeightHistoryData, (state) => weightHistoryAdapter.removeAll({ ...state }))
);
